<script setup lang="ts">
import { computed } from 'vue'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import MovesSessionLabel from './MovesSessionLabel.vue'
import MoveDropdown from './MoveDropdown.vue'
import { combinationToCard, percentToColor } from '@/lib/converters'
import { actionIcons } from '@/constants'
import type { PlayerHandHistory, PlayerLog, SuggestedAction } from '@acepoker/contract'

type SessionItem = {
  id: string | number
  type: 'title'
  percent: number
  count: number
  lastUpdatedAt?: string
}
type ScrollItem = SessionItem | PlayerLog

const props = defineProps<{
  data: PlayerHandHistory[]
}>()

const historyFlatList = computed(() => {
  return props.data.reduce((res, session) => {
    res.push({
      type: 'title',
      id: session.sessionId,
      percent: (session.correctMoves / session.totalMoves) * 100,
      count: session.totalMoves,
      lastUpdatedAt: session.lastMoveAt
    } as SessionItem)
    return res.concat(session.moves)
  }, [] as ScrollItem[])
})
</script>

<template>
  <DynamicScroller :items="historyFlatList" :min-item-size="40" class="scroller md:mb-7">
    <template v-slot="{ item, index, active }">
      <DynamicScrollerItem
        :item="item"
        :active="active"
        :size-dependencies="[item.message]"
        :data-index="index"
      >
        <MovesSessionLabel
          v-if="item.type === 'title'"
          :percent="item.percent"
          :count="item.count"
          :date="item.lastUpdatedAt"
        />
        <MoveDropdown
          v-else
          class="text-white w-full"
          :id="item.id"
          :icon="actionIcons[item.quality]"
          :playerCards="combinationToCard(item.playerCards)"
          :communityCards="combinationToCard(item.communityCards)"
          :ev="item.ev"
          :strategy="item.strategy"
          :suggestedActions="item.suggestedActions"
          :actionNameRaw="item.actionNameRaw"
          :handHistory="item.handHistory"
          :key="index"
        />
      </DynamicScrollerItem>
    </template>
    <template #after>
      <div class="h-5"></div>
    </template>
  </DynamicScroller>
</template>

<style scoped></style>
